import { Locale, LocaleCollection } from 'contentful';
import ILocale from '@app/types/base/ILocale';
import ContentfulService from './base/ContentfulService';

export default class LocaleService extends ContentfulService {
	public async getLocales(): Promise<any> {
		const locales: LocaleCollection = await this.deliveryClient.getLocales();

		return locales.items.map(
			(locale: Locale): ILocale => ({
				id: locale.sys.id,
				...locale
			})
		);
	}
}
